module.exports = __webpack_public_path__ + "files/4d7d4b372cd554af377d3492811c1bda.png";